export interface Tour {
  id: string;
  name: string;
  category: 'gunubirlik' | 'konaklamali' | 'ulasimli' | 'yurtdisi';
  duration: number;
  durationUnit: string;
  price: number;
  currency: 'TL' | '€';
  image: string;
  description: string;
  highlights: string[];
  included: string[];
}

export const gunubirlikTours: Tour[] = [
  {
    id: 'g1',
    name: 'Ankara Çıkışlı Amasra Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://public.readdy.ai/ai/img_res/7f29e53cdac62d090da228b8069303a9.jpg',
    description: 'Ankara\'dan hareketle Karadeniz\'in incisi Amasra\'nın tarihi kalesi, plajları ve balık restoranlarını keşfedin.',
    highlights: ['Amasra Kalesi', 'İkiz Limanlar', 'Bedesten Çarşısı'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g2',
    name: 'Ankara Çıkışlı Kapadokya Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Cappadocia%20hot%20air%20balloons%20fairy%20chimneys%20sunrise%20golden%20light%20rock%20formations%20valleys%20Goreme%20Turkey%20magical%20landscape&width=600&height=400&seq=g2&orientation=landscape',
    description: 'Peri bacaları ve yeraltı şehirleriyle büyülü Kapadokya\'yı günübirlik keşfedin.',
    highlights: ['Göreme Açık Hava Müzesi', 'Peri Bacaları', 'Uçhisar Kalesi'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g3',
    name: 'Ankara Çıkışlı Sapanca Maşukiye Ormanya Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Sapanca%20lake%20green%20forest%20nature%20park%20lush%20trees%20calm%20water%20reflection%20Turkey%20serene%20landscape%20summer%20sunshine&width=600&height=400&seq=g3&orientation=landscape',
    description: 'Sapanca Gölü, Maşukiye\'nin doğası ve Ormanya\'nın eşsiz parkında enfes bir gün.',
    highlights: ['Sapanca Gölü', 'Maşukiye Şelaleleri', 'Ormanya Doğa Parkı'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g4',
    name: 'Ankara Çıkışlı Eskişehir Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Eskisehir%20Porsuk%20river%20gondola%20colorful%20houses%20canal%20bridges%20city%20center%20Turkey%20vibrant%20cheerful%20scenery%20daytime&width=600&height=400&seq=g4&orientation=landscape',
    description: 'Türkiye\'nin sevimli şehri Eskişehir\'de Porsuk kanalında gondol ve tarihi mekanları keşfedin.',
    highlights: ['Porsuk Kanalı', 'Odunpazarı Evleri', 'Atlıhan Çarşısı'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g5',
    name: 'Ankara Çıkışlı Safranbolu Cam Teras Yörük Köyü',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Safranbolu%20UNESCO%20heritage%20Ottoman%20houses%20cobblestone%20streets%20historic%20town%20Turkey%20traditional%20architecture%20sunny%20day%20charming&width=600&height=400&seq=g5&orientation=landscape',
    description: 'UNESCO mirası Safranbolu\'nun tarihi konaklarını ve cam terası ziyaret edin.',
    highlights: ['Tarihi Konak Evler', 'Cam Teras', 'Yörük Köyü'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g6',
    name: 'Ankara Çıkışlı Konya Mevlana Kelebekler Vadisi',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Konya%20Mevlana%20museum%20whirling%20dervishes%20spiritual%20ancient%20mosque%20dome%20Turkey%20cultural%20heritage%20golden%20architecture%20beautiful&width=600&height=400&seq=g6&orientation=landscape',
    description: 'Mevlana\'nın şehri Konya ve eşsiz Kelebekler Vadisi\'ni bir günde keşfedin.',
    highlights: ['Mevlana Müzesi', 'Kelebekler Vadisi', 'Alaaddin Camii'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g7',
    name: 'Ankara Çıkışlı Beypazarı Abant Gölcük Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Abant%20lake%20surrounded%20by%20green%20pine%20forest%20mountains%20reflection%20calm%20water%20Turkey%20nature%20beautiful%20serene%20landscape%20autumn%20colors&width=600&height=400&seq=g7&orientation=landscape',
    description: 'Tarihi Beypazarı\'nı, Abant Gölü\'nün huzurunu ve Gölcük\'ün güzelliklerini keşfedin.',
    highlights: ['Beypazarı Çarşısı', 'Abant Gölü', 'Gölcük Tabiat Parkı'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g8',
    name: 'Ankara Çıkışlı Yedigöller Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Yedigoller%20national%20park%20seven%20lakes%20autumn%20foliage%20colorful%20trees%20reflections%20crystal%20clear%20water%20Turkey%20forest%20magical%20scenery&width=600&height=400&seq=g8&orientation=landscape',
    description: 'Yedi Göller Milli Parkı\'nın büyüleyici gölleri ve sonbahar renkleri arasında nefes kesici bir gün.',
    highlights: ['Yedi Göller', 'Doğa Yürüyüşü', 'Orman Manzarası'],
    included: ['Ulaşım', 'Rehberlik', 'Gezi programı'],
  },
  {
    id: 'g9',
    name: 'Eymir Gölü ve Tulumtaş Mağarası Turu',
    category: 'gunubirlik',
    duration: 1,
    durationUnit: 'Gün',
    price: 1200,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Eymir%20Lake%20Ankara%20serene%20calm%20water%20surrounded%20by%20green%20trees%20golden%20reeds%20reflections%20natural%20park%20peaceful%20morning%20light%20Turkish%20landscape%20wide%20open%20nature&width=600&height=400&seq=g9&orientation=landscape',
    description: 'Ankara\'nın incisi Eymir Gölü\'nün huzurlu kıyılarında yürüyüş, ardından Tulumtaş Mağarası\'nın gizemli sarkıt ve dikitleriyle dolu büyüleyici dünyasına kapılar açılıyor. Öğle yemeği Tarihi Ankara Konaklarında, araç içi sandviç paketi dahildir.',
    highlights: ['Eymir Gölü Yürüyüşü', 'Tulumtaş Mağarası', 'Tarihi Konak Yemeği'],
    included: ['Ulaşım', 'Rehberlik', 'Öğle Yemeği (Tarihi Ankara Konaklarında)', 'Araç İçi Sandviç Paketi'],
  },
];

export const konaklamaliTours: Tour[] = [
  {
    id: 'k1',
    name: 'Ankara Çıkışlı Her Şey Dahil GAP Turu 3 Gece',
    category: 'konaklamali',
    duration: 4,
    durationUnit: 'Gün',
    price: 13990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=GAP%20region%20Southeastern%20Turkey%20Gaziantep%20Sanliurfa%20Gobeklitepe%20ancient%20ruins%20historical%20mosaic%20cultural%20richness%20dramatic%20landscape%20sunny&width=600&height=400&seq=k1&orientation=landscape',
    description: 'Güneydoğu Anadolu\'nun tüm güzelliklerini her şey dahil konforla 4 günde yaşayın.',
    highlights: ['Göbeklitepe', 'Halfeti', 'Mardin'],
    included: ['Ulaşım', 'Konaklama', 'Her Şey Dahil', 'Rehber'],
  },
  {
    id: 'k2',
    name: 'Ankara Çıkışlı Her Şey Dahil GAP Turu 4 Gece',
    category: 'konaklamali',
    duration: 5,
    durationUnit: 'Gün',
    price: 17990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Mardin%20old%20city%20stone%20houses%20Mesopotamia%20valley%20panoramic%20view%20Syria%20border%20Turkey%20traditional%20architecture%20ancient%20historic&width=600&height=400&seq=k2&orientation=landscape',
    description: '5 günde GAP bölgesinin tüm hazinelerini keşfedin, her şey dahil\'in keyfini çıkarın.',
    highlights: ['Gobeklitepe', 'Urfa', 'Mardin', 'Nemrut'],
    included: ['Ulaşım', 'Konaklama', 'Her Şey Dahil', 'Rehber'],
  },
  {
    id: 'k3',
    name: 'Ankara Çıkışlı Kapadokya ve İhlara Vadisi Turu',
    category: 'konaklamali',
    duration: 2,
    durationUnit: 'Gün',
    price: 5990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Ihlara%20Valley%20Cappadocia%20canyon%20river%20green%20trees%20ancient%20churches%20carved%20rock%20Turkey%20scenic%20hiking%20trail%20dramatic%20gorge&width=600&height=400&seq=k3&orientation=landscape',
    description: 'Kapadokya\'nın efsanevi güzelliği ve İhlara Vadisi\'nin gizli güzellikleri 2 günde.',
    highlights: ['Göreme', 'İhlara Vadisi', 'Selime Manastırı'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k4',
    name: 'Sinop Erfelek Şelaleleri Kastamonu Horma Kanyonu',
    category: 'konaklamali',
    duration: 2,
    durationUnit: 'Gün',
    price: 5990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Sinop%20Black%20Sea%20coast%20castle%20harbor%20boats%20Turkey%20scenic%20port%20city%20ancient%20walls%20blue%20sea%20sunny%20summer&width=600&height=400&seq=k4&orientation=landscape',
    description: 'Sinop\'un tarihi kalesi, Erfelek şelaleleri ve Horma Kanyonu\'nun doğal güzelliği.',
    highlights: ['Erfelek Şelaleleri', 'Sinop Kalesi', 'Horma Kanyonu'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k5',
    name: 'Her Şey Dahil Karadeniz ve Batum Turu 3 Gece',
    category: 'konaklamali',
    duration: 4,
    durationUnit: 'Gün',
    price: 12990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Batumi%20Georgia%20city%20skyline%20modern%20towers%20beach%20boulevard%20Black%20Sea%20sunset%20colorful%20lights%20vibrant%20cityscape&width=600&height=400&seq=k5&orientation=landscape',
    description: 'Trabzon\'dan Batum\'a Karadeniz\'in en güzel noktalarını her şey dahil konforla keşfedin.',
    highlights: ['Trabzon', 'Sümela Manastırı', 'Batum'],
    included: ['Ulaşım', 'Konaklama', 'Her Şey Dahil', 'Rehber'],
  },
  {
    id: 'k6',
    name: 'Her Şey Dahil Karadeniz ve Batum Turu 4 Gece',
    category: 'konaklamali',
    duration: 5,
    durationUnit: 'Gün',
    price: 15990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Trabzon%20Black%20Sea%20coast%20lush%20green%20mountains%20Uzungol%20lake%20fog%20valley%20Turkey%20beautiful%20nature%20scenic&width=600&height=400&seq=k6&orientation=landscape',
    description: '5 günde Karadeniz\'den Batum\'a unutulmaz bir yolculuk, her şey dahil konforla.',
    highlights: ['Uzungöl', 'Sümela', 'Batum', 'Rize'],
    included: ['Ulaşım', 'Konaklama', 'Her Şey Dahil', 'Rehber'],
  },
  {
    id: 'k7',
    name: 'Uçaklı Karadeniz Turu 3 Gece 4 Gün',
    category: 'konaklamali',
    duration: 4,
    durationUnit: 'Gün',
    price: 20990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Sumela%20monastery%20cliff%20rock%20Trabzon%20misty%20green%20mountains%20Black%20Sea%20Turkey%20ancient%20Byzantine%20historic%20dramatic%20scenery&width=600&height=400&seq=k7&orientation=landscape',
    description: 'Uçaklı konforla Karadeniz\'in en güzel noktalarını 4 günde keşfedin.',
    highlights: ['Sümela Manastırı', 'Uzungöl', 'Trabzon'],
    included: ['Uçuş', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k8',
    name: 'Uçaklı Karadeniz ve Batum Turu 4 Gece 5 Gün',
    category: 'konaklamali',
    duration: 5,
    durationUnit: 'Gün',
    price: 24990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Batumi%20botanical%20garden%20flowers%20coastal%20city%20Georgia%20Caucasus%20mountains%20background%20colorful%20lush%20green%20tropical%20plants&width=600&height=400&seq=k8&orientation=landscape',
    description: 'Uçaklı konforla Karadeniz ve Batum\'u 5 günde keşfeden kapsamlı tur.',
    highlights: ['Trabzon', 'Sümela', 'Batum', 'Rize Çamlıhemşin'],
    included: ['Uçuş', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k9',
    name: 'Ankara Çıkışlı İstanbul Adalar Saraylar Turu',
    category: 'konaklamali',
    duration: 2,
    durationUnit: 'Gün',
    price: 6490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Istanbul%20Bosphorus%20Topkapi%20Palace%20Dolmabahce%20historic%20peninsula%20Blue%20Mosque%20skyline%20panoramic%20view%20Turkey%20golden%20hour&width=600&height=400&seq=k9&orientation=landscape',
    description: 'İstanbul\'un tarihi yarımadası, sarayları ve Prens Adaları\'nı 2 günde keşfedin.',
    highlights: ['Topkapı Sarayı', 'Prens Adaları', 'Boğaz Turu'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k10',
    name: 'İstanbul Adalar Saraylar Şile Ağva Turu 2 Gece',
    category: 'konaklamali',
    duration: 3,
    durationUnit: 'Gün',
    price: 9990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Princes%20Islands%20Istanbul%20Buyukada%20horse%20carriage%20Victorian%20houses%20green%20pine%20trees%20Marmara%20Sea%20Turkey%20charming&width=600&height=400&seq=k10&orientation=landscape',
    description: 'İstanbul\'dan Şile ve Ağva\'ya uzanan 3 günlük eşsiz Marmara ve Karadeniz turu.',
    highlights: ['Prens Adaları', 'Şile', 'Ağva'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k11',
    name: 'Çanakkale Bozcaada Assos Mudanya Trilye Bursa',
    category: 'konaklamali',
    duration: 3,
    durationUnit: 'Gün',
    price: 9990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Bozcaada%20Greek%20island%20Turkey%20Aegean%20windmills%20vineyards%20colorful%20houses%20harbor%20boats%20traditional%20architecture%20sunny&width=600&height=400&seq=k11&orientation=landscape',
    description: 'Çanakkale, Bozcaada ve Assos\'un antik güzelliğini 3 günde yaşayın.',
    highlights: ['Çanakkale', 'Bozcaada', 'Assos Antik Kenti'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k12',
    name: 'Butik Ege Turu 2 Gece 3 Gün',
    category: 'konaklamali',
    duration: 3,
    durationUnit: 'Gün',
    price: 10990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Aegean%20coast%20Turkey%20Cesme%20Alacati%20windmills%20white%20stone%20village%20bougainvillea%20flowers%20cobblestone%20streets%20charming%20boutique&width=600&height=400&seq=k12&orientation=landscape',
    description: 'Ege\'nin en güzel butik destinasyonlarını 3 günde keşfeden özel tur.',
    highlights: ['Alaçatı', 'Çeşme', 'Efes'],
    included: ['Ulaşım', 'Butik Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k13',
    name: 'Kazdağları Bozcaada Assos Ayvalık Cunda Adası',
    category: 'konaklamali',
    duration: 3,
    durationUnit: 'Gün',
    price: 10990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Kaz%20Mountains%20pine%20forest%20green%20valley%20Ida%20mountains%20Turkey%20ancient%20nature%20pristine%20beauty%20clear%20air%20lush&width=600&height=400&seq=k13&orientation=landscape',
    description: 'Kazdağları\'nın eşsiz doğası, Bozcaada ve Cunda Adası\'nı 3 günde keşfedin.',
    highlights: ['Kazdağları', 'Cunda Adası', 'Ayvalık'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k14',
    name: 'Fethiye Kaş Kalkan Likya Turu 3 Gece 4 Gün',
    category: 'konaklamali',
    duration: 4,
    durationUnit: 'Gün',
    price: 12490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Fethiye%20blue%20lagoon%20Oludeniz%20beach%20turquoise%20water%20paragliding%20Turkey%20Aegean%20Mediterranean%20coast%20beautiful%20summer&width=600&height=400&seq=k14&orientation=landscape',
    description: 'Fethiye\'den Kaş\'a Likya koylarının turquoise sularında 4 günlük deniz tatili.',
    highlights: ['Ölüdeniz', 'Kaş', 'Kalkan'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k15',
    name: 'Adrasan Olympos Tatili 3 Gece 4 Gün',
    category: 'konaklamali',
    duration: 4,
    durationUnit: 'Gün',
    price: 11490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Olympos%20Adrasan%20beach%20turquoise%20sea%20clear%20water%20pine%20trees%20ruins%20ancient%20Turkey%20Mediterranean%20paradise%20summer%20relaxing&width=600&height=400&seq=k15&orientation=landscape',
    description: 'Adrasan ve Olympos\'un eşsiz plajlarında 4 gün huzurlu tatil deneyimi.',
    highlights: ['Adrasan Plajı', 'Olympos Antik Kenti', 'Yanartaş'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'k16',
    name: 'Fethiye Kaş Kalkan Likya Turu 4 Gece 5 Gün',
    category: 'konaklamali',
    duration: 5,
    durationUnit: 'Gün',
    price: 16990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Kas%20Turkey%20harbor%20sailing%20boats%20traditional%20houses%20Mediterranean%20village%20Lycian%20tombs%20rock%20cliff%20turquoise%20water&width=600&height=400&seq=k16&orientation=landscape',
    description: 'Likya kıyısının tüm güzelliklerini 5 günde yaşayın, keşfedin ve dinlenin.',
    highlights: ['Fethiye', 'Kaş', 'Kalkan', 'Patara'],
    included: ['Ulaşım', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
];

export const ulasimliTours: Tour[] = [
  {
    id: 'u1',
    name: 'Fethiye Kaş Kalkan Likya Turu 3 Gece 4 Gün',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 12490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Fethiye%20harbor%20marina%20boats%20Taurus%20mountains%20background%20turquoise%20bay%20Turkey%20Mediterranean%20summer%20travel&width=600&height=400&seq=u1&orientation=landscape',
    description: 'Ulaşım dahil Likya kıyısında 4 gün huzurlu tatil deneyimi yaşayın.',
    highlights: ['Ölüdeniz', 'Kaş', 'Kalkan'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u2',
    name: 'Fethiye Kaş Kalkan Likya Turu 4 Gece 5 Gün',
    category: 'ulasimli',
    duration: 5,
    durationUnit: 'Gün',
    price: 16990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Kalkan%20Turkey%20whitewashed%20houses%20hillside%20Aegean%20Mediterranean%20panoramic%20sea%20view%20boutique%20hotel%20village%20charming%20sunny&width=600&height=400&seq=u2&orientation=landscape',
    description: '5 gün boyunca Likya sahillerinin en güzel noktalarını ulaşım dahil keşfedin.',
    highlights: ['Fethiye', 'Kaş', 'Kalkan', 'Patara'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u3',
    name: 'Bodrum Marmaris Datça Akyaka Pamukkale Turu 4 Gün',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 13990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Bodrum%20castle%20St%20Peter%20harbor%20sailing%20boats%20Aegean%20Sea%20Turkey%20Mediterranean%20resort%20town%20summer%20sunny%20blue%20water&width=600&height=400&seq=u3&orientation=landscape',
    description: 'Bodrum\'dan Pamukkale\'ye efsanevi Ege rotasını 4 günde ulaşım dahil keşfedin.',
    highlights: ['Bodrum', 'Datça', 'Pamukkale'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u4',
    name: 'Bodrum Marmaris Datça Akyaka Pamukkale Turu 5 Gün',
    category: 'ulasimli',
    duration: 5,
    durationUnit: 'Gün',
    price: 16490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Pamukkale%20travertine%20white%20terraces%20thermal%20pools%20turquoise%20water%20Hierapolis%20ruins%20Turkey%20unique%20natural%20wonder%20landscape&width=600&height=400&seq=u4&orientation=landscape',
    description: 'Ege ve Pamukkale\'yi 5 günde keşfedin, ulaşım dahil konforlu tur.',
    highlights: ['Marmaris', 'Akyaka', 'Pamukkale'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u5',
    name: 'Adrasan Olympos Tatili 3 Gece 4 Gün',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 11490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Adrasan%20beach%20quiet%20cove%20turquoise%20water%20pine%20trees%20mountains%20Mediterranean%20Turkey%20paradise%20secluded%20bay%20crystal%20clear&width=600&height=400&seq=u5&orientation=landscape',
    description: 'Ulaşım dahil Adrasan ve Olympos\'ta dinlendirici 4 gün tatil.',
    highlights: ['Adrasan Plajı', 'Olympos', 'Yanartaş'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u6',
    name: 'Adrasan Olympos Tatili 4 Gece 5 Gün',
    category: 'ulasimli',
    duration: 5,
    durationUnit: 'Gün',
    price: 13990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Olympos%20ancient%20ruins%20beach%20sea%20Mediterranean%20Turkey%20Lycian%20trees%20historic%20site%20natural%20beauty%20summer%20relaxation&width=600&height=400&seq=u6&orientation=landscape',
    description: 'Adrasan ve Olympos\'ta ulaşım dahil 5 gün huzurlu ve keyifli tatil.',
    highlights: ['Adrasan', 'Olympos Antik', 'Yanartaş', 'Çıralı'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u7',
    name: 'Haftalık Adrasan Tatili 7 Gece 8 Gün',
    category: 'ulasimli',
    duration: 8,
    durationUnit: 'Gün',
    price: 24490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Adrasan%20bay%20full%20week%20vacation%20turquoise%20Mediterranean%20sea%20pine%20mountains%20relaxation%20swimming%20sunbathing%20Turkey%20peaceful%20paradise%20resort&width=600&height=400&seq=u7&orientation=landscape',
    description: 'Tam 8 günlük Adrasan tatilinde dinlenmek ve yenilenmek için mükemmel seçim.',
    highlights: ['Adrasan', 'Olympos', 'Yanartaş', 'Tekne Turu'],
    included: ['Ulaşım Dahil', 'Konaklama', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u8',
    name: 'Kemer Tatili Transatlantik Hotel (Ulaşım Dahil)',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 23750,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Kemer%20Antalya%20luxury%20hotel%20pool%20beach%20pine%20mountains%20Mediterranean%20Turkey%20resort%20all%20inclusive%20summer%20holiday&width=600&height=400&seq=u8&orientation=landscape',
    description: 'Transatlantik Hotel\'de ulaşım dahil konforlu Kemer tatili deneyimi.',
    highlights: ['Kemer', 'Transatlantik Hotel', 'Plaj'],
    included: ['Ulaşım Dahil', 'Otel', 'Kahvaltı', 'Akşam Yemeği'],
  },
  {
    id: 'u9',
    name: 'Kıbrıs Turu - 2 Gece 3 Gün',
    category: 'ulasimli',
    duration: 3,
    durationUnit: 'Gün',
    price: 24990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Cyprus%20Kyrenia%20harbor%20castle%20boats%20Mediterranean%20island%20turquoise%20sea%20mountains%20sunny%20summer%20blue%20sky%20beautiful&width=600&height=400&seq=u9&orientation=landscape',
    description: 'Uçaklı Kıbrıs turunda tarihi Girne ve Lefkoşa\'yı 3 günde keşfedin.',
    highlights: ['Girne Kalesi', 'Lefkoşa', 'Bellapais Manastırı'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u10',
    name: 'Kıbrıs Turu 3 Gece 4 Gün',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 29990,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=North%20Cyprus%20Famagusta%20ancient%20city%20walls%20Othello%20castle%20ruins%20Mediterranean%20island%20historic%20architecture%20beautiful%20sunshine&width=600&height=400&seq=u10&orientation=landscape',
    description: 'Kıbrıs\'ın tüm güzelliklerini 4 günde keşfeden uçaklı kapsamlı tur.',
    highlights: ['Girne', 'Gazimağusa', 'Lefkoşa'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u11',
    name: 'Bodrum Tatili 3 Gece 4 Gün 2025',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 11490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Bodrum%20Turkey%20white%20houses%20windmill%20harbor%20sailing%20boats%20Aegean%20Sea%20summer%20iconic%20landscape%20castle%20blue%20water&width=600&height=400&seq=u11&orientation=landscape',
    description: '2025 özel fiyatlarıyla Bodrum\'un muhteşem koylarında 4 gün ulaşım dahil.',
    highlights: ['Bodrum', 'Pedasa', 'Tekne Turu'],
    included: ['Ulaşım Dahil', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'u12',
    name: 'Olympos Tatili 3 Gece 4 Gün',
    category: 'ulasimli',
    duration: 4,
    durationUnit: 'Gün',
    price: 11490,
    currency: 'TL',
    image: 'https://readdy.ai/api/search-image?query=Olympos%20beach%20Turkey%20ancient%20Lycian%20ruins%20jungle%20forest%20Mediterranean%20trees%20clear%20water%20relaxing%20summer%20nature%20paradise&width=600&height=400&seq=u12&orientation=landscape',
    description: 'Olympos\'un doğası ve antik kalıntıları arasında ulaşım dahil 4 gün tatil.',
    highlights: ['Olympos', 'Yanartaş', 'Çıralı Plajı'],
    included: ['Ulaşım Dahil', 'Otel', 'Kahvaltı', 'Rehber'],
  },
];

export const yurtdisiTours: Tour[] = [
  {
    id: 'y1',
    name: 'Ankara Hareketli Ajet Hy ile Büyük Balkan Turu',
    category: 'yurtdisi',
    duration: 8,
    durationUnit: 'Gün',
    price: 599,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Balkans%20Europe%20Belgrade%20Sofia%20Plovdiv%20historic%20cities%20colorful%20architecture%20Danube%20river%20old%20town%20travel%20scenic%20autumn&width=600&height=400&seq=y1&orientation=landscape',
    description: 'Balkan ülkelerinin tarihi şehirlerini 8 günde Ankara\'dan hareketle keşfedin.',
    highlights: ['Belgrad', 'Sofya', 'Plovdiv'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y2',
    name: 'Grand Benelux Paris Alsace Disneyland Turu',
    category: 'yurtdisi',
    duration: 8,
    durationUnit: 'Gün',
    price: 1049,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Paris%20Eiffel%20Tower%20sunset%20golden%20hour%20France%20Europe%20travel%20iconic%20landmark%20cityscape%20beautiful%20romance&width=600&height=400&seq=y2&orientation=landscape',
    description: 'Paris, Brüksel, Amsterdam ve Disneyland\'ı kapsayan 8 günlük Avrupa turu.',
    highlights: ['Paris', 'Brüksel', 'Amsterdam', 'Disneyland'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y3',
    name: 'Ankara Çıkışlı Grand İskandinavya ve Fiyordlar',
    category: 'yurtdisi',
    duration: 8,
    durationUnit: 'Gün',
    price: 1099,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Norway%20fjords%20dramatic%20landscape%20mountains%20water%20reflection%20Geiranger%20Norway%20Scandinavia%20stunning%20nature%20travel%20Europe&width=600&height=400&seq=y3&orientation=landscape',
    description: 'İskandinavya\'nın fiyordları, Stockholm ve Kopenhag\'ı 8 günde keşfedin.',
    highlights: ['Oslo', 'Fiyordlar', 'Stockholm', 'Kopenhag'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y4',
    name: 'Ankara Ajet ile Grand Alpler Üçgeni ve Alsace',
    category: 'yurtdisi',
    duration: 8,
    durationUnit: 'Gün',
    price: 1099,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Swiss%20Alps%20mountains%20lake%20Lucerne%20reflection%20white%20peaks%20snow%20Interlaken%20Switzerland%20Europe%20travel%20scenic&width=600&height=400&seq=y4&orientation=landscape',
    description: 'İsviçre Alpleri, Alsace bölgesi ve Almanya\'yı 8 günde keşfeden büyük Avrupa turu.',
    highlights: ['Zürih', 'Strasbourg', 'Münih'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y5',
    name: 'Ajet Hy ile Ekspres İspanya Turu Ankara - MAD-BCN',
    category: 'yurtdisi',
    duration: 5,
    durationUnit: 'Gün',
    price: 599,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Madrid%20Royal%20Palace%20Spain%20Plaza%20Mayor%20sunset%20golden%20Europe%20famous%20landmark%20colorful%20architecture%20travel%20summer&width=600&height=400&seq=y5&orientation=landscape',
    description: 'Madrid ve Barselona\'yı 5 günde keşfeden hızlı ve keyifli İspanya turu.',
    highlights: ['Madrid', 'Toledo', 'Barselona'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y6',
    name: 'Ajet Hy ile Viva İspanya ve Endülüs Turu Ankara',
    category: 'yurtdisi',
    duration: 7,
    durationUnit: 'Gün',
    price: 599,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Granada%20Alhambra%20palace%20Andalusia%20Spain%20moorish%20architecture%20gardens%20reflection%20orange%20trees%20Spain%20travel%20stunning&width=600&height=400&seq=y6&orientation=landscape',
    description: 'Endülüs\'ün eşsiz mirasını, flamenko kültürünü ve denizini 7 günde keşfedin.',
    highlights: ['Sevilla', 'Córdoba', 'Granada', 'Barselona'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y7',
    name: 'Ankara PGS HY ile Grand Portekiz Turu LIS-LIS',
    category: 'yurtdisi',
    duration: 5,
    durationUnit: 'Gün',
    price: 699,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Lisbon%20Portugal%20colorful%20tiles%20trams%20Alfama%20district%20sunset%20Tagus%20river%20city%20view%20travel%20Europe%20charming%20historic&width=600&height=400&seq=y7&orientation=landscape',
    description: 'Lizbon ve Porto\'nun eşsiz atmosferini 5 günde keşfeden Portekiz turu.',
    highlights: ['Lizbon', 'Porto', 'Sintra', 'Obidos'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y8',
    name: 'Ankara Ajet ile Viva Orta Avrupa Hallstatt 5',
    category: 'yurtdisi',
    duration: 7,
    durationUnit: 'Gün',
    price: 599,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Hallstatt%20Austria%20lakeside%20village%20Alps%20mountains%20reflection%20fairytale%20picturesque%20famous%20Europe%20travel%20beautiful%20sunny&width=600&height=400&seq=y8&orientation=landscape',
    description: 'Peri masalı Hallstatt, Viyana ve Prag\'ı 7 günde keşfeden Orta Avrupa turu.',
    highlights: ['Hallstatt', 'Viyana', 'Prag'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y9',
    name: 'İtalya Turu - Ankaradan Direkt Uçuş NAP-BGY',
    category: 'yurtdisi',
    duration: 8,
    durationUnit: 'Gün',
    price: 699,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Rome%20Colosseum%20ancient%20ruins%20Italy%20sunset%20golden%20light%20historic%20landmark%20travel%20Europe%20iconic%20architecture&width=600&height=400&seq=y9&orientation=landscape',
    description: 'Roma, Floransa, Venedik ve daha fazlasını kapsayan 8 günlük İtalya turu.',
    highlights: ['Napoli', 'Roma', 'Floransa', 'Venedik'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y10',
    name: 'Ankara Hareketli Fransa-İsviçre-Almanya Rüyası',
    category: 'yurtdisi',
    duration: 5,
    durationUnit: 'Gün',
    price: 599,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Rhine%20valley%20Germany%20castles%20vineyards%20autumn%20colors%20river%20boat%20cruise%20Europe%20travel%20romantic%20scenic&width=600&height=400&seq=y10&orientation=landscape',
    description: 'Fransa, İsviçre ve Almanya\'yı 5 günde keşfeden üç ülke turu.',
    highlights: ['Strazburg', 'Basel', 'Freiburg'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y11',
    name: "Ankara'dan Bakü Rüyası Turu",
    category: 'yurtdisi',
    duration: 4,
    durationUnit: 'Gün',
    price: 399,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Baku%20Azerbaijan%20flame%20towers%20night%20skyline%20Caspian%20Sea%20old%20city%20modern%20architecture%20travel%20destination&width=600&height=400&seq=y11&orientation=landscape',
    description: 'Bakü\'nün modern ve tarihi güzelliklerini 4 günde Ankara\'dan hareketle keşfedin.',
    highlights: ['İçerişehir', 'Alev Kuleleri', 'Hazar Denizi'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
  {
    id: 'y12',
    name: "Ankara'dan İspanya ve Endülüs Şehirleri Turu",
    category: 'yurtdisi',
    duration: 7,
    durationUnit: 'Gün',
    price: 899,
    currency: '€',
    image: 'https://readdy.ai/api/search-image?query=Seville%20Spain%20Giralda%20tower%20Plaza%20de%20Espana%20golden%20sunset%20Andalusia%20travel%20beautiful%20architecture%20Europe%20landmark&width=600&height=400&seq=y12&orientation=landscape',
    description: 'İspanya ve Endülüs\'ün en güzel şehirlerini 7 günde kapsamlı keşif turu.',
    highlights: ['Madrid', 'Sevilla', 'Granada', 'Barselona'],
    included: ['Uçuş', 'Otel', 'Kahvaltı', 'Rehber'],
  },
];

export const allTours: Tour[] = [
  ...gunubirlikTours,
  ...konaklamaliTours,
  ...ulasimliTours,
  ...yurtdisiTours,
];
